"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StCoreAdapter__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_correlatedToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "_underlyingToken",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "exchangeRate",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608034608657601f61029538819003918201601f19168301916001600160401b03831184841017608b578084926040948552833981010312608657604b602060458360a1565b920160a1565b600180546001600160a01b039384166001600160a01b031991821617909155600080549290931691161790556040516101e090816100b58239f35b600080fd5b634e487b7160e01b600052604160045260246000fd5b51906001600160a01b038216820360865756fe608080604052600436101561001357600080fd5b60003560e01c633ba0b9a91461002857600080fd5b3461016d57600036600319011261016d5760015463d389800f60e01b8252602090829060049082906001600160a01b03165afa90811561011a57600091610126575b50604051633ca967f360e01b815290602090829060049082906001600160a01b03165afa90811561011a576000916100e5575b50670de0b6b3a7640000810290808204670de0b6b3a764000014901517156100cf57602090620f424060405191048152f35b634e487b7160e01b600052601160045260246000fd5b906020823d602011610112575b816100ff60209383610172565b8101031261010f5750513861009d565b80fd5b3d91506100f2565b6040513d6000823e3d90fd5b6020813d602011610165575b8161013f60209383610172565b810103126101615751906001600160a01b038216820361010f5750602061006a565b5080fd5b3d9150610132565b600080fd5b90601f8019910116810190811067ffffffffffffffff82111761019457604052565b634e487b7160e01b600052604160045260246000fdfea2646970667358221220a302dacf8f76b83598013ae3674b5c442e08591f750e2e88c567879c338de0a064736f6c634300081a0033";
const isSuperArgs = (xs) => xs.length > 1;
class StCoreAdapter__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(_correlatedToken, _underlyingToken, overrides) {
        return super.getDeployTransaction(_correlatedToken, _underlyingToken, overrides || {});
    }
    deploy(_correlatedToken, _underlyingToken, overrides) {
        return super.deploy(_correlatedToken, _underlyingToken, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.StCoreAdapter__factory = StCoreAdapter__factory;
StCoreAdapter__factory.bytecode = _bytecode;
StCoreAdapter__factory.abi = _abi;
//# sourceMappingURL=StCoreAdapter__factory.js.map